import type { IconProps } from '../types/IconProps.ts';
export const LayoutDashboard: IconProps = {
    name: 'LayoutDashboard',
    children: [
        `<rect width="7" height="9" x="3" y="3" rx=".5" />`,
        `<rect width="7" height="9" x="14" y="12" rx=".5" />`,
        `<rect width="7" height="5" x="3" y="16" rx=".5" />`,
        `<rect width="7" height="5" x="14" y="3" rx=".5" />`,
    ]
};